import { create } from 'zustand';
import { getUnitPriceForQuantity, type CatalogProduct } from '../api/delivery';

export interface CartItem {
  product: CatalogProduct;
  quantity: number; // em centésimos: 100 = 1 un
}

interface CartStore {
  items: CartItem[];
  addItem: (product: CatalogProduct) => void;
  removeItem: (productId: string) => void;
  updateQuantity: (productId: string, quantity: number) => void;
  clear: () => void;
  subtotalCents: () => number;
  totalItems: () => number;
}

export const useCartStore = create<CartStore>((set, get) => ({
  items: [],

  addItem: (product) => {
    set((state) => {
      const existing = state.items.find((i) => i.product.id === product.id);
      if (existing) {
        return {
          items: state.items.map((i) =>
            i.product.id === product.id
              ? { ...i, quantity: i.quantity + 100 }
              : i,
          ),
        };
      }
      return { items: [...state.items, { product, quantity: 100 }] };
    });
  },

  removeItem: (productId) =>
    set((state) => ({ items: state.items.filter((i) => i.product.id !== productId) })),

  updateQuantity: (productId, quantity) => {
    if (quantity <= 0) {
      get().removeItem(productId);
      return;
    }
    set((state) => ({
      items: state.items.map((i) =>
        i.product.id === productId ? { ...i, quantity } : i,
      ),
    }));
  },

  clear: () => set({ items: [] }),

  subtotalCents: () =>
    get().items.reduce((acc, i) => {
      const unitQty = i.quantity / 100;
      const unitPriceCents = getUnitPriceForQuantity(i.product, unitQty);
      return acc + Math.round(unitQty * unitPriceCents);
    }, 0),

  totalItems: () =>
    get().items.reduce((acc, i) => acc + Math.round(i.quantity / 100), 0),
}));
